// extracted by mini-css-extract-plugin
export default {"container":"Details_container__2ownF","form":"Details_form__Q5Mz7","dualInput":"Details_dualInput__pGbfQ"};